import { Api } from '../AApi'

export const API_SETTING = new Api(
  { only: [] },
  {
    getGrafanaUrl: {
      request() {
        return this.sdk.get('settings/grafana').then((res) => res.data)
      },
    },
    checkEnableWMS: {
      request() {
        return this.sdk.get('settings/check-enable-wms').then((res) => res.data)
      },
    },
  }
)
